import React from "react";
import { Container, Navbar } from "react-bootstrap";

export default function Formatos() {
  return (
    <React.Fragment>
      <Navbar bg="light" expand="lg" className="bg-degradado">
        <Navbar.Brand>
          <img src="/er/img/logo-recopilador.png" height="30" alt="" /> Sistema de
          Entrega Recepción
        </Navbar.Brand>
      </Navbar>
      <Container style={{ height: "90%" }}>
        <br />
        <h3>Anexo para el proceso de entrega-recepción</h3>
        <object
          data="http://143.198.191.211/pdf/formatospublicos/"
          type="application/pdf"
          width="100%"
          height="80%"
        >
          <p>
            Tu navegador no soporta este componente{" "}
            <a href="http://143.198.191.211/pdf/formatospublicos/">
              Descárgalo
            </a>
          </p>
        </object>
      </Container>
    </React.Fragment>
  );
}
